import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API, useAuth } from "./auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json", "X-Session-ID": sessionId },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("session failed");
        const data = await res.json();
        setUser(data);
        // clear the hash so it isn't reused
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user: data } });
      } catch (e) {
        navigate("/login?error=1");
      }
    };
    run();
  }, [location.hash, navigate, setUser]);

  return (
    <div style={{ minHeight: "60vh", display: "grid", placeItems: "center",
      fontFamily: "var(--mono)", color: "var(--grey)", letterSpacing: ".1em",
      textTransform: "uppercase", fontSize: ".8rem" }}>
      Signing you in&hellip;
    </div>
  );
}
